module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Medium.a2ec212.woff";